import '@shui/core/sh-stepper';

import { Component, input, booleanAttribute, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-stepper',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.color]': 'color() ?? null',
        '[attr.condensed]': 'condensed() ? "" : null',
        '[attr.readonly]': 'readonly() ? "" : null',
        '[attr.value]': 'value() ?? null',
        '[attr.vertical]': 'vertical() ? "" : null'
    }
})
export class ShStepperComponent {
    /**
     * The property allows to switch between the 'primary' and 'neutral' versions of the stepper.
     */
    public readonly color = input<string | number | undefined>(undefined);

    /**
     * If set to `true`, the stepper will be shown in a smaller size, without label and will not be
     * interactive.
     */
    public readonly condensed = input(false, { transform: booleanAttribute });

    /** If set to `true`, the stepper will not be interactive. */
    public readonly readonly = input(false, { transform: booleanAttribute });

    /**
     * Defines which stepper-item will be active. Takes any number between 1 and the total number of
     * stepper-items.
     */
    public readonly value = input<string | number | undefined>(undefined);

    /** Defaults false. When set to true, the stepper layout transforms to vertical. */
    public readonly vertical = input(false, { transform: booleanAttribute });
}
